import { Price } from '../models/price';

export const emptyPrice: Price = {
    currency: '',
    baseFreight: null,
    surcharges: [],
    net: null,
    gross: null
};
